import * as types from './actionTypes';
import axios from 'axios';
import { getHeader, getMessageByErrorStatus } from '../helper';
import { writeOffMoneyUser } from "./session";
import { writeOffMoneyCompany } from "./companyActions";
import { setGlobalErrors } from "./globalErrorActions";

function receiveOrder(data) {
    return {
        type: types.LOAD_ORDER_SUCCESS,
        data: data
    }
}

function requestOrder(params) {
    return {
        type: types.LOAD_ORDER_REQUEST,
        params
    }
}

function orderError(messages) {
    return {
        type: types.LOAD_ORDER_FAILURE,
        messages
    }
}


export function getOrders(params = {}, headers = {}) {
    let URL = `${window.siteUrl}/api/v1/order/`;
    let newParams = Object.assign({}, params);

    if(params.uri) {
        URL = URL + params.uri + "/";
        delete newParams.uri;
    }

    return function (dispatch) {
        dispatch(requestOrder(newParams));
        dispatch(setGlobalErrors('orders', {}));

        return axios.get(URL, {
            params: newParams,
            headers: headers
        })
        .then(function (response) {
            // console.log("order creator data-", response.data);
            dispatch(receiveOrder(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("order creator error-", err.data, err.status, err.headers);
                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('orders', {status: err.status, error: errorText}));
                dispatch(orderError(err.data));
            }
        });
    }
}


function receiveMoreOrder(data) {
    return {
        type: types.LOAD_MORE_ORDER_SUCCESS,
        data: data
    }
}

function requestMoreOrder() {
    return {
        type: types.LOAD_MORE_ORDER_REQUEST
    }
}

function moreOrderError(messages) {
    return {
        type: types.LOAD_MORE_ORDER_FAILURE,
        messages
    }
}

export function getMoreOrders(args) {
    let URL = `${window.siteUrl}/api/v1/order/`;

    let defaultSettings = {
        params: {},
        headers: {}
    }

    let newSettings = Object.assign({}, defaultSettings, args, {
        params: {
            ...defaultSettings.params,
            ...args.params
        }
    });

    if(newSettings.params.uri) {
        URL = URL + newSettings.params.uri + "/";
        delete newSettings.params.uri;
    }

    if(newSettings.params.uriFull) {
        URL = newSettings.params.uriFull;
        delete newSettings.params.uriFull;
    }

    return function (dispatch) {
        dispatch(requestMoreOrder());
        dispatch(setGlobalErrors('orders', {}));

        return axios.get(URL, newSettings)
        .then(function (response) {
            // console.log("more order creator data-", response.data);
            dispatch(receiveMoreOrder(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("more order creator error-", err.data, err.status, err.headers);
                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('orders', {status: err.status, error: errorText}));
                dispatch(moreOrderError(err.data));
            }
        });
    }
}


function receiveAddLike(order) {
    return {
        type: types.ADD_LIKE_SUCCESS,
        order
    }
}

function requestAddLike(order) {
    return {
        type: types.ADD_LIKE_REQUEST,
        order
    }
}

function addLikeError(messages) {
    return {
        type: types.ADD_LIKE_FAILURE,
        messages
    }
}

export function addLike(order) {
    return function (dispatch) {
        dispatch(requestAddLike(order))

        return axios.post(
            `${window.siteUrl}/api/v1/order/${order.id}/add_like/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(receiveAddLike(order));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("add_like error", err.data, err.status, err.headers);
                 dispatch(addLikeError(err.data));
            }
        });
    }
}


function receiveAddDislike(order) {
    return {
        type: types.ADD_DISLIKE_SUCCESS,
        order
    }
}

function requestAddDislike(order) {
    return {
        type: types.ADD_DISLIKE_REQUEST,
        order
    }
}

function addDislikeError(messages) {
    return {
        type: types.ADD_DISLIKE_FAILURE,
        messages
    }
}

export function addDislike(order) {
    return function (dispatch) {
        dispatch(requestAddDislike(order))

        return axios.post(
            `${window.siteUrl}/api/v1/order/${order.id}/add_dislike/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(receiveAddDislike(order));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("add_like error", err.data, err.status, err.headers);
                dispatch(addDislikeError(err.data));
            }
        });
    }
}


function receiveCreateOrder(data) {
    return {
        type: types.CREATE_ORDER_SUCCESS,
        data
    }
}

function requestCreateOrder(params) {
    return {
        type: types.CREATE_ORDER_REQUEST,
        params
    }
}

export function createOrderError(messages) {
    return {
        type: types.CREATE_ORDER_FAILED,
        messages
    }
}

export function createOrder(params, successCallback, errorCallback) {
    return function (dispatch) {
        dispatch(requestCreateOrder(params))
        dispatch(setGlobalErrors('createorder', {}));
        
        return axios.post(
            `${window.siteUrl}/api/v1/order/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {

            // console.log("create order, response.data", params, response.data);
            dispatch(receiveCreateOrder(response.data));

            if(successCallback) {
                successCallback(response.data);
            }
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                if(err.status === 500){
                    dispatch(createOrderError({non_field_errors: ['Ошибка сервера']}));
                    errorCallback({non_field_errors: ['Ошибка сервера']})
                }
                else{
                    dispatch(createOrderError(err.data));
                    errorCallback(err.data)
                }

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('createorder', {status: err.status, error: errorText}));
            }
        });
    }
}


export function publishOrderRequest() {
    return {
        type: types.PUBLISH_ORDER_REQUEST,
    }
}

export function publishOrderReceive(data) {
    return {
        type: types.PUBLISH_ORDER_SUCCESS,
        data
    }
}

export function publishOrderError(messages) {
    return {
        type: types.PUBLISH_ORDER_FAILURE,
        messages
    }
}

export function publishOrder(params, successCallback, errorCallback) {
    return function (dispatch) {
        dispatch(publishOrderRequest());
        dispatch(setGlobalErrors('createorder', {}));
        
        return axios.post(
            `${window.siteUrl}/api/v1/order/${params.order_id}/publish/`,
            {
                company_id: params.company_id || null
            },
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            // console.log('publishing...', response.data)
            dispatch(publishOrderReceive(response.data));

            let isCompany = (!params.company_id || parseInt(params.company_id) === 0) ? false : true;

            if (isCompany) {
                // console.log('isCompany action create', params)
                dispatch(writeOffMoneyCompany(params))
            }
            else {
                // console.log('isPerson  action create', params)
                dispatch(writeOffMoneyUser(params))
            }

            if(successCallback) {
                successCallback(response.data);
            }
        })
        .catch(function (error) {
            
            if (error.response) {
                let err = error.response;
                if(err.status === 500){
                    dispatch(publishOrderError({non_field: ['Ошибка сервера']}));
                    if(errorCallback) errorCallback({non_field: ['Ошибка сервера']})
                }
                else{
                    dispatch(publishOrderError(err.data));
                    if(errorCallback) errorCallback(err.data)
                }

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('createorder', {status: err.status, error: errorText}));
            }
        });
    }
}



export function updateOrderRequest() {
    return {
        type: types.UPDATE_ORDER_REQUEST,
    }
}

export function updateOrderReceive(data) {
    return {
        type: types.UPDATE_ORDER_SUCCESS,
        data
    }
}

function updateOrderError(messages) {
    return {
        type: types.UPDATE_ORDER_FAILURE,
        messages
    }
}

export function updateOrder(params, order_id, successCallback, errorCallback) {
    return function (dispatch) {
        dispatch(updateOrderRequest());
        dispatch(setGlobalErrors('updateorder', {}));

        return axios.patch(
            `${window.siteUrl}/api/v1/order/${order_id}/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
           // console.log("updateOrderReceive", params, response.data)
            dispatch(updateOrderReceive(response.data));

            if(successCallback) {
                successCallback(response.data);
            }
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                let messages = ''

                if(err.status === 500) {
                    messages = {non_field_errors: ['Ошибка сервера']}
                }
                else if (err.data){
                    messages = err.data;
                }

                console.error('updateOrderError', messages)
                //dispatch(updateOrderError(messages));
               if(errorCallback) errorCallback(messages);

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('updateorder', {status: err.status, error: errorText}));
            }
        });
    }
}



function receiveResponseOrder(order_id) {
    return {
        type: types.ADD_RESPONSE_SUCCESS,
        order_id
    }
}

function requestResponseOrder(id) {
    return {
        type: types.ADD_RESPONSE_REQUEST,
        id
    }
}

function responseOrderError(messages) {
    return {
        type: types.ADD_RESPONSE_FAILURE,
        messages
    }
}

export function responseOrder(id, callback) {
    return function (dispatch) {
        dispatch(requestResponseOrder(id));
        dispatch(setGlobalErrors('order', {}))

        return axios.post(
            `${window.siteUrl}/api/v1/bid/`,
            {order_id: id},
            {
                headers: getHeader()
            }
        )
        .then((response) => {
            //console.log("responseOrder data", id, response.data);
            if(callback) callback();
            dispatch(receiveResponseOrder(id));
        })
        .catch((error) => {
            if (error.response) {
                let err = error.response;
                console.error("responseOrder error", err.data, err.status, err.headers);
                dispatch(responseOrderError(err.data));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('order', {status: err.status, error: errorText}))
            }
        });
    }
}


export function receiveResponseOrderByID(order_id) {
    return {
        type: types.ADD_RESPONSE_BY_ID_SUCCESS,
        order_id
    }
}

export function requestResponseOrderByID() {
    return {
        type: types.ADD_RESPONSE_BY_ID_REQUEST,
    }
}


function getOrderByIdRequest(update) {
    return {
        type: types.LOAD_ORDER_BY_ID_REQUEST,
        update
    }
}

function getOrderByIdReceive(data, count) {
    return {
        type: types.LOAD_ORDER_BY_ID_SUCCESS,
        data: data,
        count
    }
}

function getOrderByIdError(messages) {
    return {
        type: types.LOAD_ORDER_BY_ID_FAILURE,
        messages
    }
}

export function getOrderById(params = {}, headers = {}, update = false, callback) {

    return function (dispatch) {
        dispatch(getOrderByIdRequest(update));
        dispatch(setGlobalErrors('order', {}));

        return axios.get(`${window.siteUrl}/api/v1/order/`, {
            params: params,
            headers: headers
        })
        .then(function (response) {
            // console.log("getOrderByIdReceive", response.data)
            dispatch(getOrderByIdReceive(response.data.results, response.data.count));
            if(callback) {
                callback(response.data.results[0]);
            }
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getOrderByIdError", err.data, err.status, err.headers);
                dispatch(getOrderByIdError(err.data));
                if(callback) {
                    callback();
                }

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('order', {status: err.status, error: errorText}))
            }
        });
    }
}


function getExecutorsRequest() {
    return {
        type: types.LOAD_EXECUTORS_REQUEST
    }
}

function getExecutorsReceive(data) {
    return {
        type: types.LOAD_EXECUTORS_SUCCESS,
        data: data
    }
}

function getExecutorsError(messages) {
    return {
        type: types.LOAD_EXECUTORS_FAILURE,
        messages
    }
}

export function getExecutors(order_id) {

    return function (dispatch) {
        dispatch(getExecutorsRequest())

        return axios.get(`${window.siteUrl}/api/v1/bid/`, {
            params: { order_id: order_id },
            headers: getHeader()
        })
        .then(function (response) {
            dispatch(getExecutorsReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getExecutorsError", err.data, err.status, err.headers);
                dispatch(getExecutorsError(err.data));
            }
        });
    }
}


export function clearExecutor() {
    return {
        type: types.CLEAR_BID_USER,
    }
}



function getExecutorMessagesReceive(data, bid_id) {
    return {
        type: types.LOAD_EXECUTOR_MESSAGES_SUCCESS,
        data,
        bid_id
    }
}

export function getExecutorMessages(bid_id) {
    return function (dispatch) {
        axios.get(`${window.siteUrl}/api/v1/message/`, {
            params: { bid_id: bid_id }, 
            headers: getHeader()
        })
        .then(function (response) {
            //console.log("getExecutorMessagesReceive", bid_id, response.data);

            let newState = Object.assign({}, response.data, {
                results: response.data.results.reverse()
            })
            
            dispatch(setGlobalErrors('message', {}))
            dispatch(getExecutorMessagesReceive(newState, bid_id));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("error", err.data, err.status, err.headers);

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('message', {status: err.status, error: errorText}))
            }
        });
    }
}


function getExecutorMoreMessagesRequest(bid_id) {
    return {
        type: types.LOAD_EXECUTOR_MORE_MESSAGES_REQUEST,
        bid_id
    }
}

function getExecutorMoreMessagesReceive(data, bid_id) {
    return {
        type: types.LOAD_EXECUTOR_MORE_MESSAGES_SUCCESS,
        data,
        bid_id
    }
}

function getExecutorMoreMessagesError(messages, bid_id) {
    return {
        type: types.LOAD_EXECUTOR_MORE_MESSAGES_FAILURE,
        messages,
        bid_id
    }
}

export function getExecutorMoreMessages(params) {
    return function (dispatch) {

        dispatch(setGlobalErrors('message', {}));
        dispatch(getExecutorMoreMessagesRequest(params.bid_id));

        axios.get(`${window.siteUrl}/api/v1/message/`, {
            params,
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("getExecutorMoreMessages", params, response.data);

            let newState = Object.assign({}, response.data, {
                results: response.data.results.reverse()
            })
            
            dispatch(getExecutorMoreMessagesReceive(newState, params.bid_id));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getExecutorMoreMessagesError", err.data);
                dispatch(getExecutorMoreMessagesError(err.data, params.bid_id));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('message', {status: err.status, error: errorText}))
            }
        });
    }
}


function sendMessageReceive(data, bid_id) {
    return {
        type: types.SEND_MESSAGE_SUCCESS,
        data: data,
        bid_id
    }
}

export function sendMessage(params, callback, errorCallback) {
    return function (dispatch) {

        //dispatch(sendMessageRequest())
        dispatch(setGlobalErrors('message', {}))

        return axios.post(`${window.siteUrl}/api/v1/message/`,
        params,
        {
            headers: getHeader()

        }).then(function (response) {
            //console.log("post message bid", response.data);
            dispatch(sendMessageReceive(response.data, params.bid_id));

            if(callback) {
                callback(response.data)
            }
        }).catch(function (error) {
            if(callback) callback();
            if (error.response) {
                let err = error.response;
                console.error("error", err.data, err.status, err.headers);

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('message', {status: err.status, error: errorText}))
            }
        });
    }
}



function getExecutorPhotosReceive(data, bid_id) {
    return {
        type: types.LOAD_EXECUTOR_PHOTOS_SUCCESS,
        data,
        bid_id
    }
}

export function getExecutorPhotos(bid_id) {
    return function (dispatch) {
        dispatch(setGlobalErrors('work', {}))

        axios.get(`${window.siteUrl}/api/v1/photo/`, {
            params: { bid_id: bid_id },
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("getExecutorPhotosReceive", response.data);
            dispatch(getExecutorPhotosReceive(response.data, bid_id));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("error", err.data, err.status, err.headers);

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('work', {status: err.status, error: errorText}))
            }
        });
    }
}



function getExecutorVideosReceive(data, bid_id) {
    return {
        type: types.LOAD_EXECUTOR_VIDEOS_SUCCESS,
        data,
        bid_id
    }
}

export function getExecutorVideos(bid_id) {
    return function (dispatch) {
        dispatch(setGlobalErrors('work', {}))

        axios.get(`${window.siteUrl}/api/v1/video/`, {
            params: { bid_id: bid_id },
            headers: getHeader()
        })
        .then(response => {
           // console.log("getExecutorVideosReceive", response.data);
            dispatch(getExecutorVideosReceive(response.data, bid_id));
        })
        .catch(error => {
            console.error("error getExecutorVideosReceive", error);
            if(error.response) {
                let errorText = getMessageByErrorStatus(error.response.status);
                dispatch(setGlobalErrors('work', {status: error.response.status, error: errorText}))
            }
        });
    }
}



function sendComplaintReceive(data, bid_id) {
    return {
        type: types.SEND_COMPLAINT_SUCCESS,
        data: data,
        bid_id,
    }
}

function sendComplaintError(messages) {
    return {
        type: types.SEND_COMPLAINT_FAILURE,
        messages
    }
}

export function sendComplaint(params, callback) {
    return function (dispatch) {
        dispatch(setGlobalErrors('order', {}))

        return axios.post(
            `${window.siteUrl}/api/v1/complaint/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            // console.log("sendComplaintReceive", response.data)
            dispatch(sendComplaintReceive(response.data, params.bid_id));

            if(callback) callback(response.data);
        })
        .catch(function (error) {
            if (error.response) {
                console.error("sendComplaintError", error.response);
                dispatch(sendComplaintError(error.response.data));
                let errorText = getMessageByErrorStatus(error.response.status);
                dispatch(setGlobalErrors('order', {status: error.response.status, error: errorText}))
            }
        });
    }
}



function getStagesByOrderRequest() {
    return {
        type: types.LOAD_STAGES_BY_ORDER_REQUEST,
    }
}

function getStagesByOrderReceive(payload) {
    return {
        type: types.LOAD_STAGES_BY_ORDER_SUCCESS,
        payload
    }
}

function getStagesByOrderError(payload) {
    return {
        type: types.LOAD_STAGES_BY_ORDER_FAILURE,
        payload
    }
}

export function getStagesByOrder(order_id) {

    return function (dispatch) {
        dispatch(getStagesByOrderRequest());
        dispatch(setGlobalErrors('order', {}))

        return axios.get(`${window.siteUrl}/api/v1/milestone/?order_id=${order_id}`, {
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("getStagesByOrderReceive", response.data)
            dispatch(getStagesByOrderReceive(response.data));
        })
        .catch(function (error) {
            if(error.response) {
                console.error("getStagesByOrderError", error.response);
                dispatch(getStagesByOrderError(error.response.data));

                let errorText = getMessageByErrorStatus(error.response.status);
                dispatch(setGlobalErrors('order', {status: error.response.status, error: errorText}))
            }
        });
    }
}



function uploadWorkReceive(payload, bid_id) {
    return {
        type: types.UPLOAD_WORK_SUCCESS,
        payload,
        bid_id
    }
}

export function uploadWork(params, bid_id, callback, callbackError) {

    return function (dispatch) {

        return axios.post(`${window.siteUrl}/api/v1/photo/`,
            params,
            {headers: getHeader()}
        )
        .then(function (response) {
            let newImage = {
                ...response.data,
                thumb_image: response.data.thumb_image || response.data.image
            }
            // console.log("upload image success", newImage);
            if(callback) callback();
            dispatch(uploadWorkReceive(newImage, bid_id));
        })
        .catch(function (error) {
            if(callbackError) callbackError();
            if (error.response) {
                let err = error.response;
                console.error("upload image error", err.data, err.status, err.headers);
                //dispatch(orderError(error.response.data));
            }
        });
    }
}


function uploadVideoWorkReceive(payload, bid_id) {
    return {
        type: types.UPLOAD_VIDEO_WORK_SUCCESS,
        payload,
        bid_id
    }
}

export function uploadVideoWork(params, bid_id, callback, callbackError) {

    return function (dispatch) {

        return axios.post(`${window.siteUrl}/api/v1/video/`,
            params,
            {headers: getHeader()}
        )
        .then(function (response) {
            
            // console.log("upload image success", response.data);
            if(callback) callback();
            dispatch(uploadVideoWorkReceive(response.data, bid_id));
        })
        .catch(function (error) {
            if(callbackError) callbackError();
            console.error("upload video error", error);
        });
    }
}



function evaluateWorkReceive(bid_id) {
    return {
        type: types.EVALUATE_WORK_SUCCESS,
        bid_id
    }
}

export function evaluateWork(params, bid_id, callback) {
    return function (dispatch) {
        //dispatch(sendMessageRequest())
        dispatch(setGlobalErrors('order', {}));

        return axios.post(`${window.siteUrl}/api/v1/rate/`,
        params,
        {
            headers: getHeader()

        }).then(function (response) {
            // console.log("post message bid", response.data);
            dispatch(evaluateWorkReceive(bid_id));

            if(callback) {
                callback(response.data)
            }
        }).catch(function (error) {
            if(error.response) {
                console.error("error", error.response.data);

                let errorText = getMessageByErrorStatus(error.response.status);
                dispatch(setGlobalErrors('order', {status: error.response.status, error: errorText}))
            }
        });
    }
}



function acceptWorkRequest() {
    return {
        type: types.ACCEPT_WORK_REQUEST,
    }
}

function acceptWorkReceive(bid_id) {
    return {
        type: types.ACCEPT_WORK_SUCCESS,
        bid_id
    }
}

function acceptWorkError(messages) {
    return {
        type: types.ACCEPT_WORK_FAILURE,
        messages
    }
}

export function acceptWork(bid_id, successCallback, errorCallback) {
    return function (dispatch) {
        dispatch(acceptWorkRequest());
        dispatch(setGlobalErrors('order', {}));

        return axios.post(
            `${window.siteUrl}/api/v1/bid/${bid_id}/accept/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then((response) => {
            // console.log("acceptWorkReceive", bid_id, response.data);
            dispatch(acceptWorkReceive(bid_id));
            if(successCallback) successCallback();
        })
        .catch((error) => {
            if (error.response) {
                console.error("acceptWorkError", error.response.data, error.response.status);
                if(errorCallback) errorCallback();
                let errorText = getMessageByErrorStatus(error.response.status);
                dispatch(setGlobalErrors('order', {status: error.response.status, error: errorText}))
            }
        });
    }
}

export function cancelOrder() {
    return {
        type: types.CANCEL_ORDER
    }
}

function downloadWorkRequest() {
    return {
        type: types.DOWNLOAD_WORK_REQUEST
    }
}

function downloadWorkReceive(link, bid_id) {
    return {
        type: types.DOWNLOAD_WORK_SUCCESS,
        data: link,
        bid_id
    }
}

function downloadWorkError() {
    return {
        type: types.DOWNLOAD_WORK_ERROR
    }
}


export function downloadWork(bid_id, cb) {
    return function (dispatch) {
        dispatch(downloadWorkRequest());
        return axios.get(
            `${window.siteUrl}/api/v1/bid/${bid_id}/zip_archive/`,
            {
                headers: getHeader()
            }
        )
        .then((response) => {
            if(response.data.status) {
                dispatch(downloadWorkReceive(response.data, bid_id))
                cb({ link: response.data.url });
            } else {
                dispatch(downloadWorkError());
                cb({ error: { status: 404, errorMsg: response.data.non_field } })
            }
        })
        .catch((error) => {
            if (error.response) {
                console.error("acceptWorkError", error.response.data, error.response.status);
                cb({ error: { status: error.response.status, errorMsg: error.response.data } });
               // dispatch(acceptWorkError(error.response.data));
            }
        });
    }
}


function removeWorkPhotoReceive(data, bid_id) {
    return {
        type: types.REMOVE_WORK_PHOTO_SUCCESS,
        data,
        bid_id
    }
}

export function removeWorkPhoto(work, bid_id) {
    return function (dispatch) {
        dispatch(setGlobalErrors('order', {}));

        axios.delete(`${window.siteUrl}/api/v1/photo/${work.id}/`, {
            params: {}, 
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("removeWorkPhotoReceive", bid_id, response.data);

            dispatch(removeWorkPhotoReceive(work, bid_id));
        })
        .catch(function (error) {
            if(error.response) {
                let errorText = getMessageByErrorStatus(error.response.status);
                dispatch(setGlobalErrors('order', {status: error.response.status, error: errorText}))
            }
        });
    }
}


function removeWorkVideoReceive(data, bid_id) {
    return {
        type: types.REMOVE_WORK_VIDEO_SUCCESS,
        data,
        bid_id
    }
}

export function removeWorkVideo(work, bid_id) {
    return function (dispatch) {
        axios.delete(`${window.siteUrl}/api/v1/video/${work.id}/`, {
            params: {}, 
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("removeWorkVideoReceive", bid_id, response.data);

            dispatch(removeWorkVideoReceive(work, bid_id));
        })
        .catch(function (error) {
            console.error("error", error);
        });
    }
}


function quitFromOrderRequest() {
    return {
        type: types.QUIT_ORDER_REQUEST,
    }
}


function quitFromOrderReceive(executor) {
    return {
        type: types.QUIT_ORDER_SUCCESS,
        executor,
    }
}

function quitFromOrderError(messages) {
    return {
        type: types.QUIT_ORDER_FAILURE,
        messages
    }
}

export function quitFromOrder(executor, callback) {
    return function (dispatch) {
        dispatch(quitFromOrderRequest());
        dispatch(setGlobalErrors('order', {}));

        return axios.post(
            `${window.siteUrl}/api/v1/bid/${executor.id}/quit/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            // console.log("quitFromOrderReceive", response.data)
            dispatch(quitFromOrderReceive(executor));

            if(callback) callback(response.data);
        })
        .catch(function (error) {
            if (error.response) {
                console.error("quitFromOrderError", error.response);
                dispatch(quitFromOrderError(error.response.data));

                let errorText = getMessageByErrorStatus(error.response.status);
                dispatch(setGlobalErrors('order', {status: error.response.status, error: errorText}))
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/orderActions.js